@if (materia) {
  <section class="public-section article-detail-page">
    <header class="public-page-header">
      <h3 class="public-page-subtitle mb-2">{{materia.tema.nome}}</h3>
      <h2 class="public-page-title">{{materia.titulo}}</h2>
      <div class="row align-items-center">
        <div class="col-9">
          <h5 class="text-muted">{{materia.data | date:"dd/MM/yyyy"}} - {{materia.tema.nome}}</h5>
        </div>
        <div class="col-3 text-end">
          <small><a class="link-underline-light" (click)="backClicked()" style="cursor: pointer;"><i
                class="bi bi-arrow-left-short"></i> Voltar</a></small>
        </div>
      </div>
    </header>

    <img src='imagens/{{materia.data| date: "yyyyMMdd"}}/{{materia.imagemDestaque}}' alt="{{materia.imagemDestaque}}"
      [ngClass]="materia.classeImagem" (error)="handleMissingImage($event)">
    <div [innerHtml]="materia.texto"></div>
    <p>@if (materia.fonte && materia.fonte!='') {
        <small>Fonte: {{materia.fonte}}</small>
      }</p>
    <p class="text-end"><small><a class="link-underline-light" (click)="backClicked()" style="cursor: pointer;"><i
            class="bi bi-arrow-left-short"></i> Voltar</a></small></p>
    @if (materia.permiteComentario==true) {
      <div>
        <app-materia-comentario [id]="materia.id"></app-materia-comentario>
      </div>
    }
  </section>
}